<script>
import {Line} from 'vue-chartjs'

export default Line.extend({
  name: 'history-chart',
  props: ['chartData', 'barrier'],
  data() {
    return {
      options: {
        spanGaps: true,
        responsive: false,
        responsiveAnimationDuration: 0,
        animation: {
          duration: 0
        },
        layout: {
          padding: 40
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            fontSize: 40,
            boxWidth: 100,
            padding: 40,
          }
        },
        title: {
          display: false,
        },
        scales: {
          xAxes: [{
            ticks: {
              maxTicksLimit: 10,
              minRotation: 45,
              fontSize: 40,
              labelOffset: 50,
              callback(value, index, values) {
                return value + '   '
              }
            },
            id: 'regular',
            type: 'time',
            time: {
              unit: 'month',
              displayFormats: {
                month: 'DD.MM.YYYY'
              }
            },
            distribution: 'linear',
            gridLines: {
              display: true,
              drawTicks: true,
              tickMarkLength: 20,
              color: 'rgba(0, 0, 0, 0.5)'
            }
          }],
          yAxes: [{
            position: 'right',
            ticks: {
              maxTicksLimit: 10,
              fontSize: 40,
              padding: 40,
              beginAtZero: false,
              callback(value, index, values) {
                return value + '%'
              }
            },
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.5)'
            }
          }]
        }
      }
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
    this.$emit('generateChartImage', this._chart.toBase64Image())
  }
})
</script>



// WEBPACK FOOTER //
// ChartReport.vue?8771b4c6